/**
 * Dependencies.
 */
import { IAuthOptions } from '@prz-dp/services';

/**
 * Variable `baseUrl`.
 */
let baseUrl: string;

/**
 * Variable `auth`.
 */
let auth: IAuthOptions = {
  clientId: 'now',
  privateBaseUrl: '/api/.*private',
  realm: 'prozis',
  unauthorizedRouteName: 'Unauthorized'
};

/**
 * Variable `apiCustomerPublicUrl`.
 */
const apiCustomerPublicUrl = '/api/customer-dc-public';

/**
 * Variable `apiCustomerPrivateUrl`.
 */
const apiCustomerPrivateUrl = '/api/customer-dc-private';

/**
 * Variable `apiDriverDCPrivateUrl`.
 */
const apiDriverDCPrivateUrl = '/api/driver-dc-private';

/**
 * Variable `apiServicePointPrivateUrl`.
 */
const apiServicePointPrivateUrl = '/api/servicepoint-dc-private';

/**
 * Variable `minDistanceAdjustPin`, in meters.
 */
const minDistanceAdjustPin = 100;

/**
 * Variable `supportUrl`.
 */
const supportUrl =
  'https://www.prozis.com/{store}/{language}/customer-service/message-new';

/**
 * Info build mode.
 */
console.info('Build mode', process.env.BUILD_MODE);

/**
 * Build mode local.
 */
if (process.env.BUILD_MODE === 'local') {
  baseUrl = 'http://localhost:8084';

  auth = {
    ...auth,
    redirectUri: baseUrl,
    url: 'https://auth.qa.prozis.tech/auth'
  };
}

/**
 * Build mode develop.
 */
if (process.env.BUILD_MODE === 'dev') {
  baseUrl = 'https://now-customer.dev.prozis.tech';

  auth = {
    ...auth,
    redirectUri: baseUrl,
    url: 'https://auth.qa.prozis.tech/auth'
  };
}

/**
 * Build mode quality assurance.
 */
if (process.env.BUILD_MODE === 'qa') {
  baseUrl = 'https://now-customer.qa.prozis.tech';

  auth = {
    ...auth,
    redirectUri: baseUrl,
    url: 'https://auth.qa.prozis.tech/auth'
  };
}

/**
 * Build mode production.
 */
if (process.env.BUILD_MODE === 'prd') {
  baseUrl = 'https://now.prozis.com';

  auth = {
    ...auth,
    redirectUri: baseUrl,
    url: 'https://auth.prozis.tech/auth'
  };
}

/**
 * Export variables.
 */
export default {
  apiCustomerPrivateUrl,
  apiCustomerPublicUrl,
  apiDriverDCPrivateUrl,
  apiServicePointPrivateUrl,
  auth,
  baseUrl,
  minDistanceAdjustPin,
  supportUrl
};
